import {Component, Injector, Input} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {AssociationService} from "./services/association.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";

@Component({
    selector: 'app-association-activity-list',
    templateUrl: './association-activity-list.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class AssociationActivityListComponent extends BasePageComponentDirective<any> {

    @Input() providerId: number;

    activities: any[] = [];
    showCloseSearch = false;

    constructor(
        injector: Injector,
        private associationService: AssociationService,
    ) {
        super(injector);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.query();
    }

    query(): void {
        this.tableLoading = true;
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['activityType', 'conditionName', 'unitBase', 'ceuValue'];
        this.associationService.getActivitiesByProviderId(this.pageQuery, this.providerId).then(r => {
            this.activities = r.content;

            this.page.emit(r);
        });
    }

    searchUser($event: any) {
        if ($event.key === 'Enter') {
            this.searchTerm = this.pageQuery.search;
            this.query();
            this.showCloseSearch = true;
        }
    }

    clearSearch() {
        this.searchTerm = '';
        this.pageQuery.search = '';
        this.query();
        this.showCloseSearch = false;
    }

    addNewActivity() {
        this.router.navigate(['/office/association/detail/' + this.activatedRoute.snapshot.params.providerId + '/activity/add-new']).then()
    }

    detailActivity(activityId: number) {
        this.router.navigate(['/office/association/detail/' + this.activatedRoute.snapshot.params.providerId + '/activity/' + activityId + '/detail']).then();
    }

    editActivity(activityId: number) {
        this.router.navigate(['/office/association/detail/' + this.activatedRoute.snapshot.params.providerId + '/activity/' + activityId + '/edit']).then();
    }

    deleteActivity(activityId: number) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: "Delete Association Activity" ,
                subMessage: "Are you sure want to delete association activity?",
                buttonOkLabel: 'Yes, Delete',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        confirm.componentInstance.result.subscribe(r => {
            if(r) {
                this.associationService.deleteActivity(this.providerId, activityId).then(r => {
                    this.showAlertDark('Association Activity', 'Association Activity has been deleted successfully', '');
                    this.query();
                    this.router.navigate(['/office/association/detail/' + this.providerId]).then();
                })

            }
        })
    }
}
